// extracted by mini-css-extract-plugin
export default {"ChartWithLegend":"_kl0F","Legend":"ZuEWG","LegendSpacer":"hCQnE","LegendWrapper":"xkLPJ","Chart":"GYF4e","small":"Vk9WP","vertical":"aNwJO","flexChart":"cKEgJ","horizontal":"i7IBg"};